import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WestnetzPageComponent } from './westnetz-page/westnetz-page.component';
import { MaterialModule } from '../material/material.module';
import { ServiceModule } from '../../service/service.module';
import { RouterModule } from '@angular/router';
import { NavigationHeaderComponent } from './navigation-header/navigation-header.component';
import { OrgTypeReadablePipe } from '../org-type-readable/org-type-readable.pipe';
import { EscapeSomeUmlautsPipe } from '../escape-some-umlauts/escape-some-umlauts.pipe';
import { RoleFilterPipe } from './navigation-header/navigation-header-role.pipe';
import { WestnetzFooterComponent } from './westnetz-footer/westnetz-footer.component';
import { WestnetzHeaderComponent } from './westnetz-header/westnetz-header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { AnleitungOrgTypeReadablePipe } from '../anleitung-org-type-readable/org-type-readable.pipe';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        ServiceModule,
        RouterModule,
        MatSidenavModule,
    ],
    declarations: [
        WestnetzPageComponent,
        NavigationHeaderComponent,
        WestnetzHeaderComponent,
        WestnetzFooterComponent,
        OrgTypeReadablePipe,
        AnleitungOrgTypeReadablePipe,
        EscapeSomeUmlautsPipe,
        RoleFilterPipe,
    ],
    exports: [
        WestnetzPageComponent,
        NavigationHeaderComponent,
        WestnetzHeaderComponent,
        WestnetzFooterComponent,
        OrgTypeReadablePipe,
        AnleitungOrgTypeReadablePipe,
        EscapeSomeUmlautsPipe,
    ],
})
export class WestnetzModule {
}
